/**
 * EVENT_COLOR
 * Enum representing available event colors.
 *
 * @property BLUE - Blue color.
 * @property TURQUOISE - Turquoise color.
 * @property PURPLE - Purple color.
 * @property MUTED - Muted color.
 * @property RED - Red color.
 * @property YELLOW - Yellow color.
 */
export enum EVENT_COLOR {
  BLUE = 'blue',
  TURQUOISE = 'turquoise',
  PURPLE = 'purple',
  MUTED = 'muted',
  RED = 'red',
  YELLOW = 'yellow',
}
